import apiClient from "../api-client";
import { handleApiError } from "../../utils/handle-api-error";

export const searchDocumentsByName = async (
  searchTerm: string, 
  signal: any
): Promise<any> => {
  try {
    const page = 0;
    const limit = 5;
    const response = await apiClient.get<any>(
      `/kb_documents?doc_name=${searchTerm}&page=${page}&limit=${limit}`, {signal: signal}
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
